import { LocalStore } from '../LocalStore';
import Axios from 'axios';
// import Cookies from 'js-cookie';
import StaticClass from '../staticClass/index';
import { toast } from 'react-toastify';
import { createBrowserHistory } from 'history';

const AUTH_URL = 'https://dangnhapqa.danang.gov.vn/cas';

// const axiosClient = Axios.create({
//   baseURL: 'https://gis-sxd-dn.greenglobal.com.vn',//'http://localhost:3003',
//   headers: {
//     'Accept': 'application/json',
//     'Content-Type': 'application/json',
//     //Authorization: 'JWT ' + LocalStore.getInstance().read('loginSession'),
//     // withCredentials: true,
//     'Access-Control-Allow-Origin': '*',
//     'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
//     'Access-Control-Allow-Headers': 'Content-Type',
//     'Access-Control-Allow-Credentials': 'true'
//   },
// });
const axiosClient = Axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "JWT " + LocalStore.getInstance().read("loginSession"),
  },
});
axiosClient.interceptors.request.use(
  async (config) => {
    config.headers = {
      ...config.headers,
    };
    if (config.headers.isSSO) {
      config.baseURL = AUTH_URL;
    }

    // Handle token here ...
    const token = LocalStore.getInstance().read('loginSession');
    // if (token) {
    //   config.headers['Authorization'] = `Token ${token}`
    // }
    // const currentUser = firebase.auth().currentUser
    // if (currentUser) {
    //   const token = await currentUser.getIdToken()
    //   config.headers = {
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json',
    //     Authorization: `Bearer ${token}`,
    //   };
    // }

    // const token = await getFirebaseToken()

    if (token) {
      config.headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'JWT ' + LocalStore.getInstance().read('loginSession'),
      };
    }

    return config;
  },
  (error) => {
    //Do some thing
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { status } = error.response;
    if (status === 401) {
      createBrowserHistory().push('/dang-nhap');
      localStorage.removeItem('loginSession');
    }
    throw error;
  }
);

export async function AxiosPostSecretApi(url, data) {
  let { data: result } = await axiosClient.post(url, data);
  return result;
}
export async function AxiosPatchSecretApi(url, data) {
  let { data: result } = await axiosClient.patch(url, data);
  return result;
}
export async function AxiosGetSecretApi(url, data) {
  try {
    let { data: result } = await axiosClient.get(url, { withCredentials: true });
    return result;
  } catch (errorGetAPI) {
    toast.error(errorGetAPI, StaticClass.configToast);
  }
}

export async function FetchGetSecretApi(url, data) {
  try {
    var response = await fetch(url);
    var result = await response.json();
    return result;
  } catch (errorGetAPI) {
    toast.error(errorGetAPI, StaticClass.configToast);
  }
}
export async function AxiosDeleteSecretApi(url, data) {
  try {
    let { data: result } = await axiosClient.delete(url);
    return result;
  } catch (error) {
    toast.error(error, StaticClass.configToast);
  }
}

export async function AxiosGetSSOApi(url, headers) {
  try {
    let { data: result } = await axiosClient.get(url, headers);
    return result;
  } catch (error) {
    toast.error(error, StaticClass.configToast);
  }
}
